"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GenericEvents", {
  enumerable: true,
  get: function () {
    return _index.Instrument;
  }
});
var _index = require("./instrument/index");